<header class="admin-toolbar" role="banner">

  <div class="admin-toolbar-left">
    <button
      class="admin-toolbar-btn"
      type="button"
      (click)="onToggleSidebar()"
      [attr.aria-label]="sidebarOpen() ? 'Recolher menu lateral' : 'Expandir menu lateral'"
      [title]="sidebarOpen() ? 'Recolher menu' : 'Expandir menu'">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <line x1="2" y1="4.5"  x2="16" y2="4.5"  stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="9"    x2="16" y2="9"    stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="13.5" x2="16" y2="13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </svg>
    </button>

    <nav class="admin-breadcrumb" aria-label="Trilha de navegação">
      <span class="admin-breadcrumb-root">Admin</span>
      <span class="admin-breadcrumb-sep" aria-hidden="true">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M4 2L8 6L4 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="admin-breadcrumb-current" aria-current="page">{{ currentSection() }}</span>
    </nav>
  </div>

  <div class="admin-toolbar-right">

    <button
      class="admin-toolbar-btn"
      type="button"
      (click)="onToggleTheme()"
      [attr.aria-label]="isDark() ? 'Ativar modo claro' : 'Ativar modo escuro'"
      [title]="isDark() ? 'Modo claro' : 'Modo escuro'">
      @if (isDark()) {
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <circle cx="9" cy="9" r="3.5" stroke="currentColor" stroke-width="1.7"/>
          <line x1="9" y1="1"  x2="9"  y2="3"  stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          <line x1="9" y1="15" x2="9"  y2="17" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          <line x1="1" y1="9"  x2="3"  y2="9"  stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
          <line x1="15" y1="9" x2="17" y2="9"  stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        </svg>
      } @else {
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M15.5 10.5A7 7 0 0 1 7.5 2.5a7.002 7.002 0 0 0 0 13A7 7 0 0 1 15.5 10.5z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
    </button>

    <div class="admin-user-menu">
      <button
        class="admin-user-trigger"
        type="button"
        (click)="onToggleUserMenu()"
        [attr.aria-expanded]="userMenuOpen()"
        aria-haspopup="true"
        [title]="user()?.nome || ''">
        <span class="admin-user-avatar">{{ userInitials() }}</span>
      </button>

      @if (userMenuOpen()) {
        <div
          class="admin-user-dropdown"
          role="menu"
          aria-label="Menu do usuário">

          <div class="admin-user-info">
            <span class="admin-user-name">{{ user()?.nome }}</span>
            <span class="admin-user-email">{{ user()?.email }}</span>
            <span class="admin-user-role">{{ user()?.role }}</span>
          </div>

          <div class="admin-user-divider" aria-hidden="true"></div>

          <button class="admin-user-action" type="button" role="menuitem" (click)="onBackToClient()">
            Voltar ao painel cliente
          </button>

          <button class="admin-user-action danger" type="button" role="menuitem" (click)="onLogout()">
            Sair
          </button>
        </div>
      }
    </div>

  </div>

</header>
